//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import universalImageActionsTributaryButtonsTemplate from '@legacy-components/common/universal-image-actions/universal-image-actions-tributary-buttons.html';

import $ from "jquery";

import _ from "js/underscore-mixins";

(function () {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsTributaryButtons', [
    '$state',
    'UniversalImageActionsService',
    'UniversalImageActionsView',
    'UniversalImageActionsWorkflowService',
    'UniversalImageActionWorkflows',
    'ShowroomService',
    'TrackingService',
    function (
      $state,
      UniversalImageActionsService,
      UniversalImageActionsView,
      UniversalImageActionsWorkflowService,
      UniversalImageActionWorkflows,
      ShowroomService,
      TrackingService,
    ) {
      return {
        restrict: 'E',
        scope: {},
        template: universalImageActionsTributaryButtonsTemplate,
        require: '^universalImageActionsWorkflow',
        controller: [
          '$scope',
          '$timeout',
          '$rootScope',
          '$window',
          'SHOWROOM_ACTION_TYPES',
          'SHOWROOM_BUTTON_STATE',
          'SHOWROOM_NAVIGATION_STATE',
          function (
            $scope,
            $timeout,
            $rootScope,
            $window,
            SHOWROOM_ACTION_TYPES,
            SHOWROOM_BUTTON_STATE,
            SHOWROOM_NAVIGATION_STATE,
          ) {
            let currentState;

            const launchOptions =
              UniversalImageActionsService.getCurrentLaunchOptions();

            const fadeOutSuccessMessage = () => {
              $scope.model.showSaveSuccess = true;
              setTimeout(() => {
                $('.uia-save-success').fadeOut('slow', 'linear', () => {
                  $scope.model.showSaveSuccess = false;
                  $scope.$apply();
                  $('.uia-save-success').css('display', 'block');
                });
              }, 3000);
            };

            const enableDoneState = () => {
              $scope.model.showErrorWarning = false;
              $scope.model.showSave = false;
              $scope.model.currentlySaving = false;
              $scope.model.previewLoading = false;
              $scope.model.disableDone = false;
              $scope.model.disablePreview = false;
              $scope.model.disableSave = false;
            };

            const disableButtons = () => {
              $scope.model.showSave = false;
              $scope.model.currentlySaving = false;
              $scope.model.previewLoading = false;
              $scope.model.disableDone = true;
              $scope.model.disablePreview = true;
              $scope.model.disableSave = true;
            };

            const showPreviewLoading = () => {
              $scope.model.previewLoading = true;
              $scope.model.disablePreview = true;
            };

            $scope.model = {
              currentlySaving: false,
              disableDone: true,
              disablePreview: true,
              disableSave: true,
              showSave: false,
              showSkipToEnd: false,
              skipToEndReady: false,
              previewLoading: false,
              showSaveSuccess: false,
              showSaveError: false,
              showErrorWarning: false,
              workflow: UniversalImageActionsService.getCurrentWorkflow(),
              showroomLaunchContext:
                launchOptions.getShowroomLaunchContext() || {},
            };

            $scope.model.openPreview = function () {
              const actionType = $scope.model.showSave
                ? 'PreviewChanges'
                : 'Preview';
              TrackingService.recordEvent(
                ShowroomService.getTrackingCategory(),
                ShowroomService.getTrackingAction(),
                actionType,
              );
              $window.open(currentState.previewUrl);
            };

            $scope.model.saveChanges = function () {
              if ($scope.model.currentlySaving) {
                return;
              }
              $scope.model.currentlySaving = true;
              ShowroomService.saveImplementation(
                currentState.impl.id,
                currentState.impl.name,
                currentState.impl.implementationType,
                currentState.impl.sourceId,
                currentState.universalItemId,
                currentState.passthrough.passthroughUrl,
                currentState.trackingParams.trackingParamsString,
                currentState.filters.filterState,
                currentState.instances,
                currentState.passthrough.showDesktopExperience,
                currentState.emailCaptureState,
                currentState.customStringsState,
                currentState.curatedRecsId,
                currentState.useCuratedRecommendations,
                currentState.curatedProducts,
                currentState.selectedLabels,
                currentState.curatedProductsState,
                currentState.curatedMediaState,
              );
            };

            $scope.model.openFinalPanel = () => {
              TrackingService.recordEvent(
                ShowroomService.getTrackingCategory(),
                ShowroomService.getTrackingAction(),
                'SkipToLinks',
              );
              $rootScope.$broadcast(
                'uia:modal:change-workflow-state',
                UniversalImageActionsView.TributaryCustomizeLinks.name,
                4,
              );
            };

            $scope.$on('$destroy', () => {
              if ($scope.model.showSave) {
                TrackingService.recordEvent(
                  ShowroomService.getTrackingCategory(),
                  ShowroomService.getTrackingAction(),
                  'ChangesAbandoned',
                );
              }
            });

            ShowroomService.getCurrentConfigStatusObservable().subscribe(
              (state) => {
                $timeout(() => {
                  currentState = angular.copy(state);
                  $scope.model.currentState = currentState;
                  switch (currentState.buttonState) {
                    case SHOWROOM_BUTTON_STATE.LOADING: {
                      disableButtons();
                      break;
                    }
                    case SHOWROOM_BUTTON_STATE.DISABLED: {
                      $scope.model.showErrorWarning = true;
                      disableButtons();
                      break;
                    }
                    case SHOWROOM_BUTTON_STATE.DISABLED_NO_ERRORS: {
                      disableButtons();
                      break;
                    }
                    case SHOWROOM_BUTTON_STATE.READY: {
                      // If we were previously waiting for a save to complete
                      if ($scope.model.currentlySaving) {
                        fadeOutSuccessMessage();
                      }
                      enableDoneState();
                      break;
                    }
                    case SHOWROOM_BUTTON_STATE.SAVE_ERROR: {
                      enableDoneState();
                      $scope.model.showSaveError = true;
                      break;
                    }
                    case SHOWROOM_BUTTON_STATE.SAVE_REQUIRED: {
                      enableDoneState();
                      $scope.model.showSave = true;
                      break;
                    }
                    default:
                      break;
                  }

                  switch (currentState.navigationState) {
                    case SHOWROOM_NAVIGATION_STATE.NEXT_DISABLED: {
                      $scope.model.disableForwardNavigation();
                      break;
                    }
                    case SHOWROOM_NAVIGATION_STATE.READY: {
                      $scope.model.enableForwardNavigation();
                      break;
                    }
                    default: {
                      break;
                    }
                  }

                  $scope.model.showSkipToEnd =
                    currentState.showSkipToEnd &&
                    UniversalImageActionsService.getNumTaggedProducts() > 0 &&
                    _($scope).safeGet(
                      'model.showroomLaunchContext.implementationType',
                    ) !== 'ig_promoted_post' &&
                    _($scope).safeGet(
                      'model.showroomLaunchContext.implementationType',
                    ) !== 'ig_story';

                  if (
                    _(currentState.outstandingAsyncActions).contains(
                      SHOWROOM_ACTION_TYPES.UPDATE_PREVIEW_URL,
                    )
                  ) {
                    showPreviewLoading();
                  }

                  if (
                    _(currentState.outstandingAsyncActions).contains(
                      SHOWROOM_ACTION_TYPES.SAVE,
                    )
                  ) {
                    $scope.model.currentlySaving = true;
                  }
                });
              },
            );
          },
        ],
        link(scope, element, attrs, uiaWorkflowCtrl) {
          // Initially disable forward navigation until showroom workflow is ready
          scope.model.enableForwardNavigation = () => {
            uiaWorkflowCtrl.enableNext();
          };

          scope.model.disableForwardNavigation = () => {
            uiaWorkflowCtrl.disableNext();
          };

          scope.model.disableForwardNavigation();

          scope.model.close = function () {
            scope.$emit('uia:modal:close', {
              result: {
                actionCompleted: ShowroomService.getTrackingAction(),
                newShowroomData: scope.model.currentState,
              },
            });
          };

          scope.model.skipToEndReady = true;
        },
      };
    },
  ]);
})();
